import { z } from "zod";
import {
  ChatMessageSchema,
  ChatSessionSchema,
  StrategyDslSchema,
  UiMessageSchema,
} from "../entities";

/** `GET /api/chat/sessions`. */
export const ListChatSessionsResponseSchema = z.object({
  sessions: z.array(ChatSessionSchema),
});
export type ListChatSessionsResponse = z.infer<typeof ListChatSessionsResponseSchema>;

/** `POST /api/chat/sessions`. */
export const CreateChatSessionSchema = z.object({
  title: z.string().optional(),
  strategyId: z.string().optional(),
});
export type CreateChatSession = z.infer<typeof CreateChatSessionSchema>;

/** `GET /api/chat/sessions/:id` — session plus its message history. */
export const ChatSessionDetailResponseSchema = ChatSessionSchema.extend({
  messages: z.array(ChatMessageSchema),
  /**
   * True while a streaming turn is running server-side for this session (lite
   * resume). Computed by the SERVER from the session's turn-liveness heartbeat
   * against its own clock (a fresh `turn_active_at`), so clients never compare
   * server timestamps to their own clock. A refreshed client polls the detail
   * GET while this is true and merges the growing checkpointed assistant turn.
   */
  turnInFlight: z.boolean(),
});
export type ChatSessionDetailResponse = z.infer<typeof ChatSessionDetailResponseSchema>;

/**
 * `POST /api/chat/sessions/:id/stream` — SSE. Body is the running UIMessage
 * list; the response is a UIMessage stream, not modelled here.
 */
export const ChatStreamRequestSchema = z.object({
  messages: z.array(UiMessageSchema),
  model: z.string().optional(),
});
export type ChatStreamRequest = z.infer<typeof ChatStreamRequestSchema>;

/** `PUT /api/chat/sessions/:id/draft` — persist the right-panel doc. */
export const UpdateChatDraftSchema = z.object({
  draftDsl: StrategyDslSchema,
});
export type UpdateChatDraft = z.infer<typeof UpdateChatDraftSchema>;

/** `POST /api/chat/sessions/:id/save` — promote the draft to a strategy. */
export const SaveChatDraftSchema = z.object({
  name: z.string().min(1).optional(),
});
export type SaveChatDraft = z.infer<typeof SaveChatDraftSchema>;
